import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Table as ReactstrapTable } from 'reactstrap';
import TopRow from './TopRow';
import TableRow from './TableRow';
import TotalsRow from './TotalTr';
import { formatCurrency } from '../../lib/helpers/formatters';
import TotalTrPanoramica from './TopRowPanoramica';

function PanoramicaTable({ data = {}, year, history, totals = {} }) {
  const { insuranceGabettiPerc = {}, detailsTotalsInsurances } = data;
  const { lastYearPanoramica = 0 } = totals;

  const [openRows, setOpenRows] = useState({});

  const toggleDetail = (key) => {
    setOpenRows((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const renderDetailRow = (rowData) => (
    <tr>
      <td colSpan={5} style={{ background: '#f9f9f9' }}>
        <table style={{ width: '100%' }}>
          <tbody>
            <tr>
              <td>Dettaglio dovuto:</td>
              <td>Amministratori: {formatCurrency(rowData.admin)}</td>
              <td>Agenzie: {formatCurrency(rowData.agency)}</td>
              <td>Commerciali: {formatCurrency(rowData.commercial)}</td>
              <td>Associazioni: {formatCurrency(rowData.association)}</td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
  );

  return (
    <ReactstrapTable responsive hover className="data-table">
      <thead>
        <tr>
          <th />
          <th />
          <th>Imponibile totale</th>
          <th>Dovuto</th>
          <th>EC/Banca</th>
        </tr>
      </thead>
      <tbody>
        <TotalTrPanoramica totals={totals} />

        <React.Fragment>
          <tr
            onClick={(e) => {
              if (e.target.closest('.arrow-cell')) return;
              history.push(
                `/dashboard/assicurazioni?year=${year}&insuranceStartYear=${year}`
              );
            }}
          >
            <td
              className="arrow-cell"
              style={{ cursor: 'pointer', width: 40, textAlign: 'center' }}
              onClick={(e) => {
                e.stopPropagation();
                toggleDetail('insurances');
              }}
            >
              {openRows['insurances'] ? (
                <i class="fas fa-chevron-down"></i>
              ) : (
                <i class="fas fa-chevron-right"></i>
              )}
            </td>
            <td className="title">
              Compensi variabili da assicurazioni (% Extra)
            </td>
            <td className="txt-table-right">
              {formatCurrency(insuranceGabettiPerc.net || 0)}
            </td>
            <td className="txt-table-right">
              <strong>{formatCurrency(insuranceGabettiPerc.total || 0)}</strong>
            </td>
            <td className="txt-table-right">
              <strong>
                {formatCurrency(insuranceGabettiPerc.cashed || 0)}
              </strong>
            </td>
          </tr>
          {openRows['insurances'] && renderDetailRow(detailsTotalsInsurances)}
        </React.Fragment>

        <TotalsRow
          totals={{
            ...insuranceGabettiPerc,
            cashed: (insuranceGabettiPerc.cashed || 0) + lastYearPanoramica,
          }}
        />
      </tbody>
    </ReactstrapTable>
  );
}

export default withRouter(PanoramicaTable);
